import { Extension, findChildren } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
export function createCustomUniqueIdExtension() {
    return Extension.create({
        name: 'customUniqueId',
        priority: 101,
        addOptions() {
            return {
                attributeName: 'tiptapNodeId',
                types: [],
                generateID: () => window.crypto.randomUUID(),
                filterTransaction: null,
            };
        },
        addGlobalAttributes() {
            return [
                {
                    types: this.options.types,
                    attributes: {
                        [this.options.attributeName]: {
                            default: null,
                            parseHTML: (element) => element.getAttribute(this.options.attributeName),
                            renderHTML: (attributes) => {
                                if (!attributes[this.options.attributeName]) {
                                    return {};
                                }
                                return {
                                    [this.options.attributeName]: attributes[this.options.attributeName],
                                };
                            },
                        },
                    },
                },
            ];
        },
        onCreate() {
            const { tr, doc } = this.editor.state;
            const { types, attributeName, generateID } = this.options;
            let modifiedOnCreate = false;
            findChildren(doc, (node) => types.includes(node.type.name)).forEach(({ node, pos }) => {
                const existingId = node.attrs[attributeName];
                if (existingId === null ||
                    existingId === undefined ||
                    existingId === '') {
                    const newId = generateID();
                    tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        [attributeName]: newId,
                    });
                    modifiedOnCreate = true;
                }
            });
            if (modifiedOnCreate) {
                this.editor.view.dispatch(tr);
            }
        },
        addProseMirrorPlugins() {
            const extensionThis = this;
            return [
                new Plugin({
                    key: new PluginKey('customUniqueIdPlugin'),
                    appendTransaction: (transactions, oldState, newState) => {
                        const docChanged = transactions.some((transaction) => transaction.docChanged);
                        if (!docChanged) {
                            return null;
                        }
                        if (extensionThis.options.filterTransaction) {
                            const filteredTransactions = transactions.filter((transaction) => extensionThis.options.filterTransaction(transaction));
                            if (transactions.length > 0 &&
                                filteredTransactions.length === 0) {
                                return null;
                            }
                        }
                        let modified = false;
                        const tr = newState.tr;
                        newState.doc.descendants((node, pos, parent) => {
                            if (extensionThis.options.types.includes(node.type.name)) {
                                const existingId = node.attrs[extensionThis.options.attributeName];
                                if (existingId === null ||
                                    existingId === undefined ||
                                    existingId === '') {
                                    const newId = extensionThis.options.generateID();
                                    tr.setNodeMarkup(pos, undefined, {
                                        ...node.attrs,
                                        [extensionThis.options.attributeName]: newId,
                                    });
                                    modified = true;
                                }
                                return false;
                            }
                            return true;
                        });
                        if (modified) {
                            return tr;
                        }
                        return null;
                    },
                }),
            ];
        },
    });
}
//# sourceMappingURL=uniqueIdExtension.js.map